import { render } from "./Orders.vue?vue&type=template&id=375d619c&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=375d619c&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/MISTOCK/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375d619c"]])

export default __exports__